<template>
    <div class="prof-header content-container">
        <div class="header">
            <div class="title">
                {{ info.displayName }}
                <button class="button-float-right" @click="toggleSendMessage">Send Message</button>
            </div>
        </div>
        <div class="content editor" v-if="showMessage">            
            <MessageComposer v-bind="{
                recipients: [parseInt(this.memberId)],
                cancelled: this.sendMessageCancelled,
                submitted: this.sendMessageSubmitted,
                showSubject: true,
                subject: null
            }"/>            
        </div>        
        <div class="content nopad">
            <div class="col-1">
                <div><img src="/icons/avtar.png" /></div>
            </div>
            <!--<div class="col-2">
                <div>DisplayName: {{ info.displayName }}</div>
                <div>Title: {{ info.title }}</div>            
                <div>Name: {{ info.name }}</div>
                <div>Location: {{ info.location }}</div>
                <div>Email: {{ info.email }}</div>
                <div>Website: {{ info.website }}</div>        
            </div>-->
            <div class="col-3">
                <div class="member-quickstats">                    
                    <div>Join Date: {{ stats.joinDateUTC }}</div>
                    <div>Last Seen: {{ stats.lastSeenDateUTC }}</div>
                    <div>Posts: {{ stats.postCount | formatNumber}}</div>
                    <div>Avg Post/Day: {{ stats.avgPostsPerDay }}</div>
                    <div>Code Archive Entries: {{ stats.codeArchiveEntries }}</div>                    
                </div>
            </div>
        </div>        
    </div>
</template>

<script>

import MessageComposer from '../../components/Messages/MessageComposer.vue'
import dialogs from '../../modules/dialogs'

export default {
    components: {
        MessageComposer
    },
    props: ['info', 'stats', 'memberId'],
    data() {
        return {
            showMessage: false
        }
    },
    methods: {
        sendMessageCancelled() {
            this.showMessage = false;
        },
        sendMessageSubmitted() {
            this.showMessage = false;
            dialogs.alertAsync('Message sent');
        },
        toggleSendMessage() {
            this.showMessage = !this.showMessage;
        }
    }
}

</script>
